export const SHORTCUT_EVENT_SIDEBAR_TOGGLE = 'shortcut:sidebar:toggle';
export const SHORTCUT_EVENT_CREATE_NOTE = 'shortcut:create:note';
export const SHORTCUT_EVENT_CREATE_TASK = 'shortcut:create:task';
export const SHORTCUT_EVENT_CREATE_MAIL = 'shortcut:create:mail';
export const SHORTCUT_EVENT_CREATE_PHONECALL = 'shortcut:create:phonecall';
export const SHORTCUT_EVENT_CREATE_APPOINTMENT = 'shortcut:create:appointment';
export const SHORTCUT_EVENT_CHEATSHEET_TOGGLE = 'shortcut:cheatsheet:toggle';
export const SHORTCUT_EVENT_SEARCH_FIELD_FOCUS = 'shortcut:searchfield:focus';
